export default __webpack_public_path__ + "static/media/icon-arrow-down-green.bfed8c4c.svg";